<template>
  <div class="contact-sidebar">
    <div class="sidebar-item" @mouseenter="hoveredItem = 'whatsapp'" @mouseleave="hoveredItem = null">
      <div class="icon-wrapper">
        <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
      </div>
      <div class="expanded-content" :class="{ active: hoveredItem === 'whatsapp' }">
        <a href="https://wa.me/0591-22970811" target="_blank" rel="noopener" class="content-link">
          <span class="content-text">0591-22970811</span>
          <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
          </svg>
        </a>
      </div>
    </div>

    <div class="sidebar-item" @mouseenter="hoveredItem = 'email'" @mouseleave="hoveredItem = null">
      <div class="icon-wrapper">
        <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
        </svg>
      </div>
      <div class="expanded-content" :class="{ active: hoveredItem === 'email' }">
        <a href="mailto:sales@jdlpower.com" class="content-link">
          <span class="content-text">sales@jdlpower.com</span>
          <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
          </svg>
        </a>
      </div>
    </div>

    <div class="sidebar-item" @mouseenter="hoveredItem = 'qrcode'" @mouseleave="hoveredItem = null">
      <div class="icon-wrapper">
        <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm13-2h3v2h-3v-2zM14 13h2v2h-2v-2zm2 2h2v2h-2v-2zm-2 2h2v2h-2v-2zm4-4h2v2h-2v-2zm0 4h2v2h-2v-2zm2 2h2v2h-2v-2zm0 0h2v2h-2v-2z"/>
        </svg>
      </div>
      <div class="expanded-content qrcode-content" :class="{ active: hoveredItem === 'qrcode' }">
        <div class="qrcode-box">
          <div class="qrcode-placeholder">
            <img :src="require('@/assets/12.jpg')" alt="QR Code" class="qrcode-image" />
            <span class="qrcode-text">{{ $i18n.locale === 'en' ? 'QR Code' : '公众号' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 返回顶部按钮 -->
    <div class="sidebar-item to-top-item">
      <div class="icon-wrapper to-top-btn" style="border-radius: 50%;background-color: #225EAC; pointer-events: auto;" @click="scrollToTop">
        <svg class="icon" viewBox="0 0 24 24" fill="currentColor" style="color: #FFFFFF; pointer-events: none;">
          <path d="M12 2L2 12h5v10h10V12h5L12 2z"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const hoveredItem = ref(null)

const scrollToTop = (e) => {
  if (e) {
    e.preventDefault()
    e.stopPropagation()
  }
  
  // 查找所有可能的滚动容器
  const scrollElements = [
    window,
    document.documentElement,
    document.body,
    document.querySelector('#app'),
    document.querySelector('html'),
    document.querySelector('body')
  ]
  
  // 平滑滚动函数
  const smoothScrollTo = (element, target) => {
    if (!element) return false
    
    try {
      if (element === window) {
        element.scrollTo({
          top: target,
          left: 0,
          behavior: 'smooth'
        })
        return true
      } else if (element.scrollTo) {
        element.scrollTo({
          top: target,
          left: 0,
          behavior: 'smooth'
        })
        return true
      } else if (element.scrollTop !== undefined) {
        // 手动实现平滑滚动
        const start = element.scrollTop || window.pageYOffset || document.documentElement.scrollTop
        const distance = target - start
        const duration = 500
        let startTime = null
        
        const animateScroll = (currentTime) => {
          if (startTime === null) startTime = currentTime
          const timeElapsed = currentTime - startTime
          const progress = Math.min(timeElapsed / duration, 1)
          
          // 使用缓动函数
          const ease = progress < 0.5 
            ? 2 * progress * progress 
            : 1 - Math.pow(-2 * progress + 2, 2) / 2
          
          const current = start + distance * ease
          
          if (element === window) {
            window.scrollTo(0, current)
          } else {
            element.scrollTop = current
          }
          
          if (timeElapsed < duration) {
            requestAnimationFrame(animateScroll)
          } else {
            // 确保最终位置
            if (element === window) {
              window.scrollTo(0, target)
            } else {
              element.scrollTop = target
            }
          }
        }
        
        requestAnimationFrame(animateScroll)
        return true
      }
    } catch (err) {
      console.log('Scroll failed for element:', element, err)
    }
    
    return false
  }
  
  // 优先处理 document.body，因为它是实际的滚动容器
  let scrolled = false
  
  // 方式1: 优先处理 document.body 的滚动
  if (document.body.scrollTop > 0) {
    try {
      const start = document.body.scrollTop
      const duration = 500
      let startTime = null
      
      const animateBodyScroll = (currentTime) => {
        if (startTime === null) startTime = currentTime
        const timeElapsed = currentTime - startTime
        const progress = Math.min(timeElapsed / duration, 1)
        
        // 使用缓动函数
        const ease = progress < 0.5 
          ? 2 * progress * progress 
          : 1 - Math.pow(-2 * progress + 2, 2) / 2
        
        document.body.scrollTop = start * (1 - ease)
        
        if (timeElapsed < duration) {
          requestAnimationFrame(animateBodyScroll)
        } else {
          document.body.scrollTop = 0
        }
      }
      
      requestAnimationFrame(animateBodyScroll)
      scrolled = true
    } catch (err) {
      console.log('Body scroll animation failed:', err)
    }
  }
  
  // 方式2: 如果 body 滚动失败，尝试 window.scrollTo
  if (!scrolled && window.scrollTo) {
    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      scrolled = true
    } catch (err) {
      console.log('window.scrollTo failed:', err)
    }
  }
  
  // 方式3: 尝试所有可能的滚动元素
  if (!scrolled) {
    for (const element of scrollElements) {
      if (element && smoothScrollTo(element, 0)) {
        scrolled = true
        break
      }
    }
  }
  
  // 方式4: 最后的降级方案 - 直接设置 scrollTop (立即滚动，无动画)
  if (!scrolled) {
    try {
      // 直接设置 scrollTop (立即滚动)
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      scrolled = true
    } catch (err) {
      console.log('Direct scrollTop failed:', err)
    }
  }
}
</script>

<style scoped>
/* 右侧联系侧边栏 */
.contact-sidebar {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: #B2B2B2;
  border-radius: 35px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.sidebar-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 5px 0;
}

.icon-wrapper {
  width: 40px;
  height: 40px;
  background: #e5e7eb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 2;
}

.icon-wrapper:hover {
  background: #225EAC;
}

.icon {
  width: 24px;
  height: 24px;
  color: #225EAC;
  transition: color 0.3s ease;
}
.icon-wrapper:hover {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.icon-wrapper:hover .icon {
  color: #ffffff;
}

.expanded-content {
  position: absolute;
  right: 40px;
  top: 5px;
  background: #225EAC;
  border-radius: 25px 0 0 25px;
  padding: 0 10px 0 20px;
  height: 40px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  opacity: 0;
  transform: translateX(20px);
  transition: all 0.3s ease;
  pointer-events: none;
  z-index: 1;
}

.expanded-content.active {
  opacity: 1;
  transform: translateX(0);
  pointer-events: auto;
}

.content-link {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
}

.content-link .icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.content-text {
  color: #ffffff;
}

/* 二维码展开内容 */
.qrcode-content {
  padding: 20px ;
  height: auto;
  min-height: 50px;
}

.qrcode-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.qrcode-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  min-width: 180px;
}

.qrcode-image {
  width: 120px;
  height: 120px;
  object-fit: contain;
  display: block;
}

.qrcode-text {
  color: #225EAC;
  font-size: 14px;
  font-weight: 500;
}

/* 返回顶部按钮特殊样式 */
.to-top-item {
  margin-top: 4px;
}

.to-top-btn {
  cursor: pointer !important;
  user-select: none;
}

.to-top-btn:active {
  transform: scale(0.95);
}

@media (max-width: 900px) {
  .contact-sidebar {
    display: none;
  }
}
</style>

